let ip = 'http://47.81.37.83';
if (process.env.NODE_ENV === 'production') {
  ip = 'https://api.autola.cc';
}
const http = ip + "/api/v1/"
const path = {
    ip: ip,
    upload: http + 'upload',
    login: http + 'admin/login',
    logout: http + 'admin/logout',
    home: http + 'admin/home',
    common_info: http + 'admin/home/common_info',
    tag_info: http + 'admin/home/tag_info',
    change_tag_info: http + 'admin/home/change_tag_info',
    add_tag_info: http + 'admin/home/add_tag_info',
    brand_list: http + 'admin/home/brand_list',
    change_brand_info: http + 'admin/home/change_brand_info',
    add_brand_info: http + 'admin/home/add_brand_info',
    category_list: http + 'admin/home/category_list',
    change_category_info: http + 'admin/home/change_category_info',
    add_category_info: http + 'admin/home/add_category_info',
    price_list: http + 'admin/home/price_list',
    change_price_info: http + 'admin/home/change_price_info',
    add_price_info: http + 'admin/home/add_price_info',
    color_list: http + 'admin/home/color_list',
    change_color_info: http + 'admin/home/change_color_info',
    add_color_info: http + 'admin/home/add_color_info',
    energy_list: http + 'admin/home/energy_list',
    change_energy_info: http + 'admin/home/change_energy_info',
    add_energy_info: http + 'admin/home/add_energy_info',
    drive_list: http + 'admin/home/drive_list',
    change_drive_info: http + 'admin/home/change_drive_info',
    add_drive_info: http + 'admin/home/add_drive_info',
    gear_list: http + 'admin/home/gear_list',
    change_gear_info: http + 'admin/home/change_gear_info',
    add_gear_info: http + 'admin/home/add_gear_info',
    car_list: http + 'admin/home/car_list',
    change_car_info: http + 'admin/home/change_car_info',
    add_car_info: http + 'admin/home/add_car_info',
    show_count: http + 'admin/home/show_count',
    vendor_list: http + 'admin/home/vendor_list',
    change_vendor_info: http + 'admin/home/change_vendor_info',
    add_vendor_info: http + 'admin/home/add_vendor_info',
    zhuanqu: http + 'admin/home/zhuanqu'
}
export default path;



// WEBPACK FOOTER //
// ./src/common/config.js